import DeleteIcon from "@mui/icons-material/Delete"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import deviceService from "services/deviceService"
import { removeDevice } from "slices/deviceSlice"
import { hiabColors } from "theme"
import type { IDevice } from "types/deviceTypes"

type Props = {
  device: IDevice
}

export function DeleteDeviceDialog({ device }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickDeleteDeviceGroup = () => {
    setIsLoading(true)

    deviceService
      .deleteDevice(device.id)
      .then(() => {
        dispatch(removeDevice(device))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <DeleteIcon sx={{ marginRight: 1 }} />
        Delete
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{"Delete Device"}</DialogTitle>
        <DialogContent>
          <DialogContentText>{"Are you sure you want to delete this device?"}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleClickDeleteDeviceGroup}
              disabled={isLoading}
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Delete
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
